import axios from "axios"
import { IGetPersonnelListingRequestModel, IGetPersonnelListingResponseModel } from "./_models"
import { CONST_API_PERSONNEL_LISTING_ENDPOINT } from "../../../../endpoints"

export function getPersonnelListingRequest(payload: IGetPersonnelListingRequestModel) {
     return axios.post<IGetPersonnelListingResponseModel>(CONST_API_PERSONNEL_LISTING_ENDPOINT, payload)
}
